<script setup>
  import ClientListComponent from "@/Components/Clients/ClientListComponent.vue";
  // import TasksPendingClientDashComponent from "@/Components/TasksPending/TasksPendingClientDashComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid >
    <v-row>
      <v-col cols="12" v-if="Permissions.checkPermissions(['clients.list'])">
        <ClientListComponent/>
      </v-col>
<!--      <v-col cols="6" v-if="Permissions.checkPermissions(['tasks-pending.list-client'])">-->
<!--        <TasksPendingClientDashComponent/>-->
<!--      </v-col>-->
    </v-row>
  </v-container>
</template>